import React from 'react';
import Objective from './Objective';
import Objective1 from './Objective1/Objective1';
import Objective2 from './Objective2/Objective2';
import Objective3 from './Objective3/Objective3';

export default function Pages() {
  return (
    <div>
      <Objective />
      <Objective1 />
      <Objective2 />
      <Objective3 />
    </div>
  );
}
